import { render } from "./CompleteRegisterPage.vue?vue&type=template&id=63a69094&ts=true"
import script from "./CompleteRegisterPage.vue?vue&type=script&lang=ts"
export * from "./CompleteRegisterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__